import { render, staticRenderFns } from "./v5.vue?vue&type=template&id=c27668da&scoped=true&"
import script from "./v5.vue?vue&type=script&lang=js&"
export * from "./v5.vue?vue&type=script&lang=js&"
import style0 from "./v5.vue?vue&type=style&index=0&id=c27668da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27668da",
  null
  
)

export default component.exports